import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/gym/$venueUuid/loyalty/")({
  loader: () => {
    throw redirect({
      to: "./quests",
      from: "/gym/$venueUuid/loyalty/",
    });
  },
});
